import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { Form, Image, InputGroup } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";
import { Controller, useForm } from "react-hook-form";
import { createColumnHelper } from "@tanstack/react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faKey,
  faEdit,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

import {
  emptyString,
  roleTypeEnums,
  loginConstants,
  ProfileNameText,
  groupsConstants,
  managerDropDown,
  filteringOptions,
  userBrandDropDown,
  franchiseDropDown,
  userFilterDropDown,
  userProfileDropDown,
  franchiseOptionLabel,
  userPermissionsConstants,
  modalSize,
  profileTypeDropdownNames,
  userPermissionHeadingNames,
  userPermissionsFieldsNames,
  inputFieldNames,
  phoneConstants,
  BUTTON_TEXT,
  EMPTY_ARRAY_LENGTH,
} from "../../constants";
import { storesConstants } from "../../../admin-screens/constants";
import { managersConstants } from "../../../group-screens/constants";
import { getItemFromStorage } from "../../../../system";
import {
  useSpinner,
  Option,
  Spinner,
  DataTable,
  customStyle,
  handleSpace,
  getClassName,
  ValueContainer,
  SelectComponent,
  loadingIndicator,
  paginatedPostRequestBody,
  isSuperAdmin as checkIsSuperAdmin,
  isManagerAdmin,
  isGroupAdmin,
  onKeyDownHandler,
  UTCToDateFormat,
  getUserFormSelectStyles,
  handleAsyncAction,
} from "../../../../shared";
import {
  getConfirmationModal,
  resetPasswordUserPermission,
} from "../../../../shared/components/popups/allModals";
import ModalTypeProps from "../../../../shared/components/popups";
import reInviteIcon from "../../../../assets/images/re-invite.png";
import AddGroupsModal from "../../../../shared/components/popups/addFranchisePopup/addGroupPopup";
import { groupsActions, userPermissionsActions } from "../../redux/actions";
import { storeActions } from "../../../admin-screens/redux/actions";
import { managersActions } from "../../../group-screens/redux/actions";
import { generateImagePath } from "../../../../shared/components/sidebarContainer/utility";

const DisableReInviteIcon = (imagePathFromHub) => (
  <Image
    width={20}
    role="button"
    aria-hidden="true"
    src={generateImagePath(imagePathFromHub, reInviteIcon)}
    className={`remove-button font-14-px pt-1 my-auto mx-1 disabled-icon`}
  />
);
const DisableCrossIcon = (
  <FontAwesomeIcon
    icon={faTimesCircle}
    role="button"
    aria-hidden="true"
    className="text-danger font-14-px pt-1 remove-button my-auto mx-2 disabled-icon"
  />
);
const DisableEditIcon = (
  <FontAwesomeIcon
    icon={faEdit}
    role="button"
    aria-hidden="true"
    className="font-14-px pt-1 me-2 disabled-icon"
  />
);
const DisableKeyIcon = (
  <FontAwesomeIcon
    icon={faKey}
    role="button"
    aria-hidden="true"
    className="text-dark font-14-px pt-1 remove-button my-auto disabled-icon ms-2"
  />
);

const {
  ROLE,
  GROUP,
  BRANDS,
  GROUPS,
  GROUP_ID,
  MANAGER,
  ALL_BRANDS,
  SUPER_ADMIN,
  BRAND_ADMIN,
  PROFILE_TYPE,
  FRANCHISE_ID,
  USER_PERMISSION_DATA,
} = userPermissionsConstants;

const SCROLL_BEHAVIOR_SMOOTH = "smooth";
const { ADD, ADD_FRANCHISE } = franchiseOptionLabel;
const { ADD_NEW_USER, EDIT_USER } = userPermissionHeadingNames;
const { BRAND_ID, BRAND_IDS } = userPermissionsFieldsNames;
const { BRAND_LOCATIONS_IDS } = inputFieldNames;

const SUPER_ADMIN_ROLE = roleTypeEnums.SUPER_ADMIN.toString();
const columnHelper = createColumnHelper();

const UserPermissions = (props) => {
  const {
    storesReducer: { allBrands, allBrandsForFilterDropdown },
    groupsReducer: { groups, groupCreated },
    userPermissionsReducer: {
      user,
      userDeleted,
      permissionData,
      userPermissionData,
      permissionDataPagination,
    },

    getUsers,
    getGroups,
    resetStores,
    updateUsers,
    getUserById,
    setUserData,
    allLocations,
    getAllBrands,
    getStoreById,
    imagePathFromHub,
    getBrandlocations,
    addUserPermission,
    authenticationUser,
    getLocationsByBrandId,
    resendCreatePasswordEmail,
    getAllBrandForFilterDropdown,
  } = props;

  const userFormRef = useRef(null);
  const getFranchise = useRef(true);

  let localRole = getItemFromStorage(loginConstants.ROLE);
  const filteredOptions = filteringOptions[localRole] || [];

  const {
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  //Initialize states
  const [isOpen, setIsOpen] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [canEditInfo, setCanEditInfo] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [modalElement, setModalElement] = useState(null);
  const [rowData, setRowData] = useState({});
  const [brandName, setBrandName] = useState({});
  const [brandValue, setBrandValue] = useState(false);
  const [franchiseName, setFranchiseName] = useState({});
  const [filteredDataValue, setFilteredDataValue] = useState(null);
  const [brandOptionValue, setBrandOptionValue] = useState(null);
  const [searchStr, setSearchStr] = useState(emptyString);
  const [sorting, setSorting] = useState({ id: "name", desc: true });
  const [brandsList, setBrandsList] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState(rowData?.storeIds || []);

  const brandFilterOptions = [
    { value: null, name: ALL_BRANDS },
    ...allBrandsForFilterDropdown.map((data) => {
      return { value: data.id, name: data.name };
    }),
  ];

  // Show loading while a request is running.
  const spinner = useSpinner();

  const cellNameRenderer = useCallback(
    ({ row }) => {
      const role = row.original.roleId;
      return <span>{ProfileNameText[role] || emptyString}</span>;
    },
    // eslint-disable-next-line
    []
  );

  const isValidRole = (roleId) => {
    return (
      (localRole === GROUP && roleId === roleTypeEnums.GROUP) ||
      (localRole === MANAGER && roleId === roleTypeEnums.MANAGER) ||
      (localRole === BRAND_ADMIN && roleId === roleTypeEnums.BRAND_ADMIN) ||
      (localRole === SUPER_ADMIN && roleId === roleTypeEnums.SUPER_ADMIN)
    );
  };

  const cellActionRenderer = useCallback(
    ({ row }) => {
      const { id, roleId, phoneNumber } = row.original;

      if (id) {
        if (isValidRole(roleId)) {
          if (id === authenticationUser.id) {
            return (
              <span className="d-flex align-items-center justify-content-between">
                <FontAwesomeIcon
                  icon={faEdit}
                  role="button"
                  aria-hidden="true"
                  data-testid="edit-icon"
                  className="font-14-px pt-1 me-2"
                  onClick={() => getUserPermissionsData(row.original.id)}
                />
                {DisableReInviteIcon(imagePathFromHub)}
                {DisableCrossIcon}
                <FontAwesomeIcon
                  icon={faKey}
                  role="button"
                  aria-hidden="true"
                  data-testid="change-password-icon"
                  onClick={() => resetPasswordModal(row.original.id)}
                  className="text-dark font-14-px pt-1 remove-button my-auto"
                />
              </span>
            );
          }
          return (
            <span className="d-flex align-items-center justify-content-between">
              {DisableEditIcon}
              {DisableReInviteIcon(imagePathFromHub)}
              {DisableCrossIcon}
              {DisableKeyIcon}
            </span>
          );
        }

        if (
          authenticationUser.roleId === roleTypeEnums.SUPER_ADMIN &&
          roleId === roleTypeEnums.EMAIL_ONLY
        ) {
          return (
            <span className="d-flex align-items-center justify-content-between">
              <FontAwesomeIcon
                icon={faEdit}
                role="button"
                aria-hidden="true"
                data-testid="edit-icon"
                className="font-14-px pt-1 me-2"
                onClick={() => getUserPermissionsData(row.original.id)}
              />
              {DisableReInviteIcon(imagePathFromHub)}
              <FontAwesomeIcon
                icon={faTimesCircle}
                role="button"
                aria-hidden="true"
                data-testid="delete-icon"
                onClick={() => getUserPermissionConfirmation(id)}
                className="text-danger font-14-px pt-1 remove-button my-auto mx-2"
              />
              {DisableKeyIcon}
            </span>
          );
        } else if (roleId === roleTypeEnums.EMAIL_ONLY) {
          return (
            <span className="d-flex align-items-center justify-content-between">
              {DisableEditIcon}
              {DisableReInviteIcon(imagePathFromHub)}
              {DisableCrossIcon}
              {DisableKeyIcon}
            </span>
          );
        }

        return (
          <span className="d-flex align-items-center justify-content-between">
            <FontAwesomeIcon
              icon={faEdit}
              role="button"
              aria-hidden="true"
              data-testid="edit-icon"
              className={`font-14-px pt-1 ${getClassName(
                !phoneNumber,
                "disabled-icon"
              )}`}
              onClick={() => getUserPermissionsData(row.original.id)}
            />
            <Image
              width={20}
              role="button"
              aria-hidden="true"
              data-testid="reinvite-icon"
              src={generateImagePath(imagePathFromHub, reInviteIcon)}
              className={`remove-button font-14-px pt-1 my-auto mx-1 ${getClassName(
                phoneNumber,
                "disabled-icon"
              )}`}
              onClick={() => resendCreatePasswordEmail(id)}
            />
            <FontAwesomeIcon
              icon={faTimesCircle}
              role="button"
              aria-hidden="true"
              data-testid="delete-icon"
              onClick={() => getUserPermissionConfirmation(id)}
              className="text-danger font-14-px pt-1 remove-button my-auto mx-2"
            />
            <FontAwesomeIcon
              icon={faKey}
              role="button"
              aria-hidden="true"
              data-testid="change-password-icon"
              onClick={() => resetPasswordModal(id)}
              className={`text-dark font-14-px pt-1 remove-button my-auto ${getClassName(
                !phoneNumber,
                "disabled-icon"
              )}`}
            />
          </span>
        );
      }
    },
    // eslint-disable-next-line
    [authenticationUser.id, authenticationUser.roleId]
  );

  //static headers for data table
  const userPermissionColumns = useMemo(
    () => [
      columnHelper.accessor("name", {
        header: () => "NAME",
      }),
      columnHelper.accessor("email", {
        header: () => "EMAIL",
      }),
      columnHelper.accessor("phoneNumber", {
        header: () => "PHONE",
      }),
      columnHelper.accessor("roleId", {
        header: () => "PROFILE",
        cell: cellNameRenderer,
      }),
      columnHelper.accessor("lastLogin", {
        header: () => "LAST LOGIN",
        cell: ({ row }) => {
          const userData = row.original;
          if (userData.id) {
            return userData.lastLogin
              ? UTCToDateFormat(userData.lastLogin)
              : emptyString;
          }
        },
      }),
      columnHelper.accessor("action", {
        header: "ACTION",
        enableSorting: false,
        cell: cellActionRenderer,
      }),
    ],
    [cellNameRenderer, cellActionRenderer]
  );

  // set pagination details with request body
  const getPaginatedPostRequestBody = (pageNumber, sortBy) => {
    const filter = createfilter();

    const requestBody = paginatedPostRequestBody(
      permissionDataPagination,
      pageNumber,
      searchStr,
      sortBy || sorting,
      filter
    );
    if (sortBy) {
      setSorting(sortBy);
    }
    return requestBody;
  };

  //Get data
  const getData = (pageNumber, sortBy) => {
    const requestBody = getPaginatedPostRequestBody(pageNumber, sortBy);
    getUsers(requestBody);
  };

  //To open the modal
  const openModal = () => {
    setShowModal(true);
  };

  //To close the modal
  const closeModal = () => {
    setShowModal(false);
  };

  //Setting modal component
  const setComponent = (component) => {
    setModalElement(component);
    openModal();
  };

  //Load new data after the user permission is successfully submitted
  function loadNewData() {
    getData(0);
  }

  const handleSpaceOnPaste = (e) => {
    if (e.target.value > 0) {
      setRowData({
        ...rowData,
        [e.target.name]: e.target.value?.trim(),
      });
    }
  };

  //Open update modal for user permissions
  const getUserPermissionsData = (id) => {
    setUserData(null);
    getUserById(id);
    setCanEditInfo(true);
    userFormRef.current?.scrollIntoView({ behavior: SCROLL_BEHAVIOR_SMOOTH });
  };

  //Get User confirmation delete modal
  const getUserPermissionConfirmation = (userId) => {
    setComponent(
      getConfirmationModal({
        onClose: closeModal,
        Title: BUTTON_TEXT.CONFIRM,
        message: userPermissionsConstants.DELETE_USER_MESSAGE,
        ModalSize: modalSize.MODAL_SIZE_MEDIUM,
        onConfirm: () => {
          handleAsyncAction(props.deleteUser(userId), {
            onSuccess: closeModal,
          });
        },
      })
    );
  };

  //Get User confirmation delete modal
  const resetPasswordModal = (userId) => {
    setComponent(
      resetPasswordUserPermission({
        onClose: closeModal,
        userId: userId,
      })
    );
  };

  //Handle change function to save changes in state
  const handleChange = (e, flag, fieldName, resetValues = []) => {
    if (!flag) {
      setRowTargetValue(e, false, null, resetValues);
    } else {
      setRowTargetValue(e, flag, fieldName, resetValues);
    }
  };

  // set group id and manager id null when role is Mnager
  const handleRowDataonBrandChange = (e, flag, name, brand) => {
    const updatedValue = getUpdatedValue(e, flag, name);
    const keyName = flag ? name : e.target.name;
    if (brand) {
      handleBrandChangeWithBrand(keyName, updatedValue);
    } else {
      handleBrandChangeWithoutBrand(keyName, updatedValue, name);
    }
  };

  const getUpdatedValue = (e, flag, name) => {
    if (!flag) {
      return e.target.value;
    }
    if (name === BRAND_IDS) {
      return e.length > 0 ? e.map((item) => item.id) : [e.value || e.id];
    }
    return e.value || e.id;
  };

  const handleBrandChangeWithBrand = (keyName, updatedValue) => {
    setFranchiseName({});
    setRowData({
      ...rowData,
      groupId: null,
      [keyName]: updatedValue,
    });
  };

  const handleBrandChangeWithoutBrand = (keyName, updatedValue, name) => {
    if (shouldUpdateBrandIds(name)) {
      setRowData({
        ...rowData,
        brandIds: [brandName.id],
        [keyName]: updatedValue,
      });
    } else {
      setRowData({
        ...rowData,
        [keyName]: updatedValue,
      });
    }
  };

  const shouldUpdateBrandIds = (name) => {
    return (
      rowData?.brandIds?.length === 0 && brandName?.id && name === BRAND_IDS
    );
  };

  //Handle brand change function to save changes in state
  const handleBrandChange = (e, brandName) => {
    let brandId = e.id;
    if (
      brandId &&
      (rowData?.roleId === roleTypeEnums.GROUP ||
        rowData?.roleId === roleTypeEnums.MANAGER ||
        rowData?.roleId === roleTypeEnums.EMAIL_ONLY)
    ) {
      getGroups(brandId);
    }

    if (
      brandId &&
      (rowData?.roleId === roleTypeEnums.MANAGER ||
        rowData?.roleId === roleTypeEnums.EMAIL_ONLY) &&
      rowData?.groupId
    ) {
      getBrandlocations(rowData?.groupId);
    }

    if (rowData?.roleId === roleTypeEnums.BRAND_ADMIN) {
      handleRowDataonBrandChange(e, true, BRAND_IDS, brandName);
      return;
    }

    handleRowDataonBrandChange(e, true, BRAND_ID, brandName);
  };

  //Function to Close Window to add user
  const closeAddUserWindow = () => {
    resetStores();
    setAddUser(false);
    setIsUpdate(false);
    setCanEditInfo(false);
    setIsSuperAdmin(false);
    reset();
    setRowData({});
    setFranchiseName(emptyString);
    setBrandName(emptyString);
    setBrandsList([]);
    resetSelectedStores();
    setStores([]);
    setUserData(null);
  };

  //Function to Open Window to add user
  const openAddUserWindow = () => {
    setUserData(null);
    setAddUser(true);
    setIsSuperAdmin(false);
    reset();
    resetSelectedStores();
    setStores([]);
    //If individual user login then roleType dropdown value should be selected by default
    //same for brandId when group admin or brand admin login then brandId should be selected
    if (isGroupAdmin() || isManagerAdmin()) {
      setRowData({
        brandId: allBrands[0]?.id,
        brandIds: allBrands.map((brand) => brand.id),
      });
    } else {
      setRowData({});
    }
  };

  //OnSubmit function to submit all the data on submission
  const onSubmit = () => {
    if (isUpdate) {
      let newData = {
        ...rowData,
        name: rowData?.name?.trim(),
        email: rowData?.email?.trim(),
        phoneNumber:
          user?.roleId === roleTypeEnums.EMAIL_ONLY
            ? emptyString
            : `${phoneConstants.COUNTRY_CODE}${rowData?.phoneNumber}`,
        roleId: rowData?.roleId,
        id: rowData?.id,
        brandId: rowData?.brandId,
        storeId: rowData?.storeId,
      };
      updateUsers(newData, authenticationUser.id);
      setIsUpdate(false);
      setCanEditInfo(false);
      setAddUser(false);
    } else {
      let obj = {
        ...rowData,
        name: rowData?.name?.trim(),
        email: rowData?.email?.trim(),
        roleId: rowData?.roleId,
        brandId:
          localRole !== SUPER_ADMIN && allBrands[0].id
            ? allBrands[0].id
            : rowData?.brandId,
        storeId: rowData?.storeId,
      };
      handleAsyncAction(addUserPermission(obj));
      setAddUser(false);
    }
    setRowData({});
    setBrandsList([]);
    setBrandName({});
    setFranchiseName({});
    reset();
    resetSelectedStores();
    setStores([]);
  };

  //Function to check role of a user
  const checkRole = (e) =>
    setIsSuperAdmin(e.name === ROLE && e.value === SUPER_ADMIN);

  //Set filter for the select dropdown
  const setFilteredData = (e) => {
    if (
      e.name !== emptyString &&
      (e.value === emptyString || e.value === null)
    ) {
      setFilteredDataValue(null);
    } else {
      setFilteredDataValue({
        roleId: e.value,
      });
      if (e.value === SUPER_ADMIN_ROLE) {
        setBrandOptionValue(brandFilterOptions[0]);
      }
    }
  };

  const setBrandFilterData = (e) => {
    if (
      e.name !== emptyString &&
      (e.value === emptyString || e.value === null)
    ) {
      setBrandOptionValue(null);
    } else {
      setBrandOptionValue(e);
    }
  };

  const createfilter = () => {
    let query = emptyString;
    if (filteredDataValue) {
      query = `x=>x.RoleId = ${filteredDataValue?.roleId}`;
    }
    if (query === emptyString && brandOptionValue?.value) {
      query = `x => x.BrandId == ${brandOptionValue.value} || x.SystemUserBrands.Any(brand => brand.BrandId == ${brandOptionValue.value})`;
    } else if (query !== emptyString && brandOptionValue?.value) {
      query = `${query} And (x.BrandId == ${brandOptionValue.value} || x.SystemUserBrands.Any(brand => brand.BrandId == ${brandOptionValue.value}))`;
    }
    return query;
  };

  //Function to set rowData and email validation state
  const setRowTargetValue = (e, flag, name, resetValues = []) => {
    const updatedValue = getUpdatedValue(e, flag, name);
    const keyName = flag ? name : e.target.name;

    setRowData((prevRowData) => {
      let baseData = { ...prevRowData };

      if (Array.isArray(resetValues)) {
        resetValues.forEach((key) => delete baseData[key]);
      } else {
        baseData = { ...baseData, ...resetValues };
      }

      const newRowData = {
        ...baseData,
        [keyName]: updatedValue,
      };

      if (name === GROUP_ID && !isUpdate) {
        delete newRowData.managerId;
      }
      return newRowData;
    });

    if (isManagerOrGroupAdmin(name)) {
      const defaultBrand = allBrands?.[0];
      setBrandName(defaultBrand);
      setRowData((prev) => ({
        ...prev,
        brandId: defaultBrand?.id,
      }));
    }
  };

  const isManagerOrGroupAdmin = (name) => {
    return (isManagerAdmin() || isGroupAdmin()) && !isUpdate && name === ROLE;
  };

  //Custome styles for react select

  const changeBrandValue = () => {
    if (allBrands) {
      let obj;
      let brandIdsValue;
      if (
        rowData?.brandId &&
        (rowData?.brandIds?.length <= 0 || rowData?.brandIds == null)
      ) {
        obj = allBrands.find((brand) => brand.id === rowData.brandId);
        brandIdsValue = [obj];
      } else if (rowData?.brandIds?.length > 0) {
        obj = rowData.brandIds
          .map((id) => allBrands.find((brand) => brand.id === id))
          .filter(Boolean);
        brandIdsValue = obj;
      }
      if (obj) {
        setBrandName(obj);
        setBrandsList(brandIdsValue);
        handleBrandChange(obj);
      }
    }
  };

  //Function to set name of profile type dropdown
  const handleProfileTypeName = (roleId) => {
    if (roleId === roleTypeEnums.SUPER_ADMIN) {
      return profileTypeDropdownNames.SUPER_ADMIN;
    } else if (roleId === roleTypeEnums.BRAND_ADMIN) {
      return profileTypeDropdownNames.BRAND_ADMIN;
    } else if (roleId === roleTypeEnums.GROUP) {
      return profileTypeDropdownNames.GROUP;
    } else if (roleId === roleTypeEnums.MANAGER) {
      return profileTypeDropdownNames.MANAGER;
    } else if (roleId === roleTypeEnums.EMAIL_ONLY) {
      return profileTypeDropdownNames.EMAIL_ONLY;
    } else {
      return PROFILE_TYPE;
    }
  };

  const profileTypeOptions = () => {
    let option = [{ value: emptyString, name: PROFILE_TYPE }];

    switch (localRole) {
      case SUPER_ADMIN:
        return [...option, ...userProfileDropDown];
      case BRAND_ADMIN:
        return [...option, ...userBrandDropDown];
      case GROUP:
        return [...option, ...franchiseDropDown];
      case MANAGER:
        return [...managerDropDown];
      default:
        return []; // Empty options array for other roles or no role specified
    }
  };

  const shouldHideBasedOnRole = () => {
    const { roleId, brandId, groupId, storeIds, brandIds } = rowData || {};

    const shouldHide = !(
      roleId === roleTypeEnums.SUPER_ADMIN ||
      (roleId === roleTypeEnums.BRAND_ADMIN && brandIds?.[0]) ||
      (roleId === roleTypeEnums.GROUP && brandId && groupId) ||
      ((roleId === roleTypeEnums.MANAGER ||
        roleId === roleTypeEnums.EMAIL_ONLY) &&
        brandId &&
        groupId &&
        storeIds &&
        rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH)
    );

    return shouldHide && !isUpdate;
  };

  const getOptionLabel = (option) => {
    return option.id === ADD ? (
      <span style={{ color: "blue" }}>{option.name}</span>
    ) : (
      option.name
    );
  };

  const getOptionStyle = (styles, { data }) => {
    return data.id === ADD
      ? {
          ...styles,
          color: "blue",
          cursor: "pointer",
        }
      : styles;
  };

  const handleFranchiseSelect = (e) => {
    if (e && e.name === ADD_FRANCHISE) {
      setIsOpen(true);
    } else {
      setFranchiseName(e);
      handleChange(e, true, FRANCHISE_ID);
      checkRole(e);
      if (
        (checkIsSuperAdmin() &&
          (rowData?.roleId === roleTypeEnums.MANAGER ||
            rowData?.roleId === roleTypeEnums.EMAIL_ONLY)) ||
        (!isUpdate &&
          (rowData?.roleId === roleTypeEnums.MANAGER ||
            rowData?.roleId === roleTypeEnums.EMAIL_ONLY))
      ) {
        resetSelectedStores();
      }
    }
    if (
      (rowData?.roleId === roleTypeEnums.MANAGER ||
        rowData?.roleId === roleTypeEnums.EMAIL_ONLY ||
        localRole === GROUP) &&
      e?.name !== ADD_FRANCHISE &&
      e.id
    ) {
      getBrandlocations(e.id);
    }
  };

  //Groups Info popup
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const getConditionalModal = () => {
    if (isOpen) {
      return (
        <AddGroupsModal
          {...ModalTypeProps.AddGroupsModal}
          onClose={togglePopup}
        />
      );
    }
  };
  //Handle Change function to set rowData and checkedItems
  const handleSelectedStores = (e) => {
    const { name, value } = e.target || e;

    setRowData({ ...rowData, [name]: value });
  };

  //Function to reset states
  const resetSelectedStores = () => {
    setSelectedStores([]);
    setRowData((previousValue) => ({
      ...previousValue,
      storeIds: [],
    }));
  };

  const handleUserRoleChange = (e) => {
    resetSelectedStores();
    setBrandName({});
    setBrandsList([]);

    const resetValues = ["brandId", "brandIds", "groupId", "storeIds"];

    handleChange(e, true, ROLE, resetValues);
    checkRole(e);
  };

  const isBrandCSS = () => {
    return (
      isSuperAdmin ||
      rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
      !rowData?.roleId
    );
  };

  const isGroupCSS = () => {
    return (
      isSuperAdmin ||
      rowData?.roleId === roleTypeEnums.BRAND_ADMIN ||
      rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
      rowData?.roleId === undefined ||
      !rowData?.brandId
    );
  };

  const isStoreCSS = () => {
    return (
      isSuperAdmin ||
      (rowData?.roleId !== roleTypeEnums.MANAGER &&
        rowData?.roleId !== roleTypeEnums.EMAIL_ONLY) ||
      rowData?.roleId === undefined ||
      !rowData?.groupId
    );
  };

  const isBrandFieldRuleForBrandAdmin = () => {
    return !(
      rowData?.brandIds?.filter((id) => id !== undefined).length > 0 ||
      rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
      (localRole !== SUPER_ADMIN && localRole !== BRAND_ADMIN)
    );
  };

  const isBrandFieldRuleForOther = () => {
    return !(
      rowData?.brandId ||
      rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
      (localRole !== SUPER_ADMIN && localRole !== BRAND_ADMIN)
    );
  };

  const isGroupFieldRule = () => {
    return !(
      rowData?.groupId ||
      rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
      rowData?.roleId === roleTypeEnums.BRAND_ADMIN
    );
  };

  const isStoreFieldRule = () => {
    return (
      (rowData?.roleId === roleTypeEnums.MANAGER ||
        rowData?.roleId === roleTypeEnums.EMAIL_ONLY) &&
      !(rowData?.storeIds && rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH)
    );
  };

  //Getting names against brandId
  useEffect(() => {
    //If allBrands from reducers is present then execute the following
    changeBrandValue();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allBrands]);

  //Getting names against groupId
  useEffect(() => {
    //If groups from reducers is present then execute the following
    if (groups?.data) {
      let obj = groups?.data?.find((group) => group.id === rowData?.groupId);
      setFranchiseName(obj);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups?.data]);

  //Getting all the users
  useEffect(() => {
    loadNewData();
    // eslint-disable-next-line
  }, [
    searchStr,
    brandOptionValue,
    filteredDataValue,
    userPermissionData,
    userDeleted,
  ]);

  //Getting all the users
  useEffect(() => {
    if (getFranchise.current) {
      getFranchise.current = false;
      return;
    }
    if (rowData?.brandId) {
      getGroups(rowData?.brandId);
    }
    // eslint-disable-next-line
  }, [groupCreated]);

  //Get groups and stores if we change brandId
  const initialRender = useRef(true);
  useEffect(() => {
    const isManagerOrGroupWithBrandId =
      (rowData?.roleId === roleTypeEnums.GROUP ||
        rowData?.roleId === roleTypeEnums.MANAGER) &&
      rowData?.brandId;

    if (initialRender.current) {
      initialRender.current = false;
    } else if (isManagerOrGroupWithBrandId) {
      getGroups(rowData?.brandId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData?.brandId, rowData?.roleId]);

  useEffect(() => {
    if (allLocations) {
      setStores(allLocations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLocations]);

  //UseEffect for getting data of brand and stores for adding groups
  useEffect(() => {
    if (
      (rowData?.roleId === roleTypeEnums.GROUP ||
        rowData?.roleId === roleTypeEnums.MANAGER) &&
      rowData?.brandId &&
      isOpen
    ) {
      getStoreById(rowData?.brandId);
      if (isOpen) {
        getLocationsByBrandId(rowData?.brandId);
      }
    }
    // eslint-disable-next-line
  }, [isOpen]);

  useEffect(() => {
    if (
      (localRole === GROUP || localRole === MANAGER) &&
      groups?.data?.length
    ) {
      handleFranchiseSelect(groups?.data[0]);
    }
    // eslint-disable-next-line
  }, [groups]);

  useEffect(() => {
    //If the user is manager then role should be selected by default
    if (localRole === MANAGER) {
      handleChange(managerDropDown[0], true, ROLE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUser]);

  useEffect(() => {
    if (canEditInfo) {
      setIsUpdate(true);
      setAddUser(true);
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canEditInfo]);

  useEffect(() => {
    if (Object.keys(user || {}).length) {
      setRowData({
        ...user,
        ...(user?.phoneNumber?.length > phoneConstants.LENGTH && {
          phoneNumber: user.phoneNumber.replace(
            phoneConstants.COUNTRY_CODE,
            emptyString
          ),
        }),
      });
      setBrandValue(true);
      if (
        (props.userData?.roleId === roleTypeEnums.MANAGER ||
          props.userData?.roleId === roleTypeEnums.EMAIL_ONLY) &&
        isUpdate
      ) {
        getBrandlocations(props.userData.groupId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (stores && isUpdate) {
      const filteredLocations = stores.filter((location) =>
        rowData?.storeIds?.includes(location.id)
      );
      setSelectedStores(filteredLocations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stores]);

  useEffect(() => {
    if (brandValue) {
      changeBrandValue();
      setBrandValue(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandValue]);

  useEffect(() => {
    getAllBrands(true);
    getAllBrandForFilterDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/*Modal here */}
      {showModal && modalElement}
      {getConditionalModal()}
      {/*End Modal */}
      <div ref={userFormRef} className="py-3 container-fluid">
        <div className="row align-items-center pb-3">
          <div className="col-md-6 col-lg-3">
            <div className="input-group">
              <span className="input-group-text bg-white text-secondary">
                <i className="fa fa-search" />
              </span>
              <DebounceInput
                value={searchStr}
                placeholder="Search users"
                type="text"
                className="form-control rounded-end"
                debounceTimeout={userPermissionsConstants.SEARCH_DEBOUNCE_MS}
                onChange={(e) => setSearchStr(e.target.value)}
              />
              {searchStr?.length > 0 && (
                <span
                  role="button"
                  tabIndex={0}
                  className="user-input-reset"
                  data-testid="resetSearchString"
                  onClick={() => setSearchStr(emptyString)}
                  onKeyDown={(e) => {
                    onKeyDownHandler(e, () => {
                      setSearchStr(emptyString);
                    });
                  }}
                >
                  <i className="fa fa-times" />
                </span>
              )}
            </div>
          </div>
          <div className="col-lg-3 col-md-6 my-1 ">
            <Select
              data-testid="role-base-filter"
              name="role"
              options={userFilterDropDown.filter((f) => {
                return !filteredOptions.includes(parseInt(f.value));
              })}
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.name}
              components={{
                IndicatorSeparator: () => null,
              }}
              defaultValue={userFilterDropDown[0]}
              isSearchable={true}
              styles={customStyle}
              isMulti={false}
              onChange={(e) => {
                setFilteredData(e);
              }}
            />
          </div>
          <div className="col-md-6 col-lg-3 my-1">
            <Select
              data-testid="brand-base-filter"
              name="brand"
              options={brandFilterOptions}
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.name}
              value={
                filteredDataValue?.roleId === SUPER_ADMIN_ROLE ||
                brandOptionValue === null
                  ? brandFilterOptions[0]
                  : brandOptionValue
              }
              components={{
                IndicatorSeparator: () => null,
              }}
              isSearchable={true}
              styles={customStyle}
              isMulti={false}
              onChange={(e) => {
                setBrandFilterData(e);
              }}
              isDisabled={filteredDataValue?.roleId === SUPER_ADMIN_ROLE}
            />
          </div>
          <div className="col-md-6 col-lg-3 d-flex justify-content-end">
            <button
              type="button"
              className="btn user-permission-button "
              disabled={addUser}
              onClick={() => {
                openAddUserWindow();
              }}
            >
              <i className="fa fa-plus mx-1" /> New User
            </button>
          </div>
        </div>

        <div
          className={`notification-form card shadow px-4 pt-2 my-4 ${getClassName(
            !(addUser || isUpdate),
            "d-none"
          )}`}
          data-testid="add-new-user-div"
        >
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row new-user">
                <div className="col-12">
                  <h5>{isUpdate ? EDIT_USER : ADD_NEW_USER}</h5>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  {/* Profile Type: */}
                  <div className="form-group mb-3 col-sm-12 d-flex justify-content-between mt-md-0 mt-3">
                    <h6 htmlFor="role" className="mt-2 col-md-3 col-4">
                      Profile Type:
                    </h6>
                    <Controller
                      name="roleId"
                      control={control}
                      data-testid="profile-type"
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={[
                            {
                              value: rowData?.roleId || emptyString,
                              name: handleProfileTypeName(rowData?.roleId),
                            },
                          ]}
                          options={profileTypeOptions()}
                          components={{
                            IndicatorSeparator: () => null,
                          }}
                          getOptionValue={(option) => option.value}
                          getOptionLabel={(option) => option.name}
                          onChange={(e) => {
                            handleUserRoleChange(e);
                          }}
                          placeholder={PROFILE_TYPE}
                          isSearchable={true}
                          styles={getUserFormSelectStyles(
                            errors.roleId,
                            rowData?.roleId
                          )}
                          className="w-100 font-14-px text-secondary"
                          isDisabled={isUpdate && localRole !== SUPER_ADMIN}
                        />
                      )}
                      rules={{ required: !rowData?.roleId }}
                    />
                  </div>
                  {/* Brand: */}
                  <div
                    className={`form-group mb-3  col-sm-12  d-flex justify-content-between ${getClassName(
                      isBrandCSS(),
                      "d-none"
                    )}`}
                  >
                    <h6 htmlFor="brand" className="mt-2 col-md-3 col-4">
                      Brand:
                    </h6>
                    {rowData?.roleId !== roleTypeEnums.BRAND_ADMIN ? (
                      <Controller
                        name="brandId"
                        control={control}
                        render={({ field }) => (
                          <SelectComponent
                            {...field}
                            name="brandId"
                            value={[
                              {
                                id: brandName?.id || emptyString,
                                name: brandName?.name || BRANDS,
                              },
                            ]}
                            options={
                              localRole === SUPER_ADMIN
                                ? [
                                    { id: emptyString, name: BRANDS },
                                    ...allBrands,
                                  ]
                                : allBrands
                            }
                            onChange={(e) => {
                              setBrandName(e);
                              handleBrandChange(e, BRANDS);
                              checkRole(e);
                            }}
                            placeholder={BRANDS}
                            styles={getUserFormSelectStyles(
                              errors.brandId,
                              rowData?.brandId
                            )}
                            isLoading={
                              spinner(storesConstants.FETCH_ALL_BRANDS)
                            }
                            isDisabled={
                              spinner(storesConstants.FETCH_ALL_BRANDS) ||
                              (isUpdate && localRole !== SUPER_ADMIN)
                            }
                          />
                        )}
                        rules={{
                          required: isBrandFieldRuleForOther(),
                        }}
                      />
                    ) : (
                      <Controller
                        name="brandIds"
                        control={control}
                        render={({ field }) => (
                          <SelectComponent
                            {...field}
                            name="brandIds"
                            isMulti
                            value={brandsList.length > 0 ? brandsList : []}
                            options={allBrands}
                            onChange={(e) => {
                              setBrandsList(e);
                              handleBrandChange(e);
                              checkRole(e);
                            }}
                            placeholder={BRANDS}
                            styles={getUserFormSelectStyles(
                              errors.brandIds,
                              rowData?.brandIds?.length > 0
                                ? rowData?.brandIds[0]
                                : rowData?.brandIds
                            )}
                            isLoading={
                              spinner(storesConstants.FETCH_ALL_BRANDS)
                            }
                            isDisabled={
                              spinner(storesConstants.FETCH_ALL_BRANDS) ||
                              (isUpdate && localRole !== SUPER_ADMIN)
                            }
                          />
                        )}
                        rules={{
                          required: isBrandFieldRuleForBrandAdmin(),
                        }}
                      />
                    )}
                  </div>
                  {/* Groups: */}
                  <div
                    className={`form-group mb-3  col-sm-12 d-flex justify-content-between align-self-start ${getClassName(
                      isGroupCSS(),
                      "d-none"
                    )}`}
                  >
                    <h6 htmlFor="groupId" className="mt-2 col-md-3 col-4">
                      Groups:
                    </h6>
                    <Controller
                      name="groupId"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={
                            localRole === GROUP
                              ? groups.data || []
                              : [
                                  {
                                    id: franchiseName?.id || emptyString,
                                    name: franchiseName?.name || GROUPS,
                                  },
                                ]
                          }
                          options={
                            localRole !== GROUP && localRole !== MANAGER
                              ? [
                                  { id: emptyString, name: GROUPS },
                                  ...(groups.data || []),
                                  { id: ADD, name: ADD_FRANCHISE },
                                ]
                              : groups.data
                          }
                          components={{
                            IndicatorSeparator: () => null,
                            LoadingIndicator: loadingIndicator,
                          }}
                          getOptionValue={(option) => option.id}
                          getOptionLabel={getOptionLabel}
                          onChange={handleFranchiseSelect}
                          placeholder={GROUPS}
                          isSearchable={true}
                          styles={{
                            ...getUserFormSelectStyles(
                              errors.groupId,
                              rowData?.groupId
                            ),
                            option: getOptionStyle,
                          }}
                          className="w-100 font-14-px text-secondary"
                          data-testid="groups-field"
                          id="groupId"
                          isDisabled={
                            localRole === SUPER_ADMIN
                              ? false
                              : spinner(groupsConstants.GROUPS_DATA) ||
                                !rowData?.brandId ||
                                isUpdate
                          }
                          isLoading={spinner(groupsConstants.GROUPS_DATA)}
                        />
                      )}
                      rules={{
                        required: isGroupFieldRule(),
                      }}
                    />
                  </div>
                  {/* Stores: */}
                  <div
                    className={`form-group mb-3  col-sm-12 d-flex justify-content-between align-self-start ${getClassName(
                      isStoreCSS(),
                      "d-none"
                    )}`}
                  >
                    <h6
                      htmlFor="storeIds"
                      className="mt-2 col-md-3 col-4 text-truncate"
                    >
                      Stores:
                    </h6>
                    <div className="col-md-9 col-8">
                      <Controller
                        name="storeIds"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            value={selectedStores}
                            closeMenuOnSelect={false}
                            options={stores}
                            components={{
                              Option,
                              ValueContainer: ValueContainer,
                              IndicatorSeparator: () => null,
                              LoadingIndicator: loadingIndicator,
                            }}
                            isMulti
                            hideSelectedOptions={false}
                            maxMenuHeight={200}
                            getOptionValue={(option) => option.id}
                            getOptionLabel={(option) => option.name}
                            onChange={(e) => {
                              let obj = {
                                name: BRAND_LOCATIONS_IDS,
                                value: e.map((loc) => loc.id),
                                checked: true,
                              };
                              handleSelectedStores(obj);
                              setSelectedStores(e);
                            }}
                            placeholder="Select Stores"
                            isSearchable={true}
                            styles={{
                              ...getUserFormSelectStyles(
                                errors.storeIds,
                                rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH
                                  ? rowData?.storeIds[0]
                                  : undefined
                              ),
                              option: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isSelected
                                  ? "transparent"
                                  : emptyString,
                                color: "black",
                              }),
                            }}
                            className="w-100 font-14-px text-secondary"
                            id="storeIds"
                            isDisabled={
                              localRole === SUPER_ADMIN
                                ? false
                                : spinner(managersConstants.MANAGERS_DATA) ||
                                  !rowData?.groupId ||
                                  isUpdate
                            }
                            isLoading={
                              spinner(managersConstants.MANAGERS_DATA)
                            }
                          />
                        )}
                        rules={{
                          required: isStoreFieldRule(),
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Name, Email and Phone Number */}
                <div
                  className={`col-md-6 ${
                    shouldHideBasedOnRole() ? "d-none" : ""
                  }`}
                >
                  {/* name */}
                  <div className="form-group mb-3  col-sm-12 d-flex justify-content-between">
                    <h6 htmlFor="name" className="mt-2 col-md-2 col-4">
                      Name:
                    </h6>
                    <input
                      type="text"
                      name="name"
                      minLength={1}
                      maxLength={100}
                      data-testid="name-field"
                      value={rowData?.name}
                      {...register("name", {
                        required: !rowData?.name,
                        onChange: (e) => handleChange(e),
                      })}
                      onInput={(e) => {
                        if (register?.("name")?.onChange) {
                          register("name").onChange(e);
                        }
                      }}
                      onKeyDown={(e) => handleSpace(e)}
                      onPaste={(e) => handleSpaceOnPaste(e)}
                      className={`w-100 form-control font-14-px text-secondary ${getClassName(
                        errors.name,
                        "is-invalid"
                      )}`}
                    />
                  </div>
                  {/* Email: */}
                  <div className="form-group mb-3  col-sm-12 d-flex justify-content-between">
                    <h6 htmlFor="email" className="mt-2 col-md-2 col-4">
                      Email:
                    </h6>
                    <input
                      type="text"
                      name="email"
                      value={rowData?.email || emptyString}
                      minLength={1}
                      maxLength={100}
                      data-testid="email-field"
                      {...register("email", {
                        required: !rowData?.email,
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Email is not valid",
                        },
                        onChange: (e) => handleChange(e),
                      })}
                      onInput={(e) => {
                        if (register?.("email")?.onChange) {
                          register("email").onChange(e);
                        }
                      }}
                      onKeyDown={(e) => handleSpace(e)}
                      className={`w-100 form-control font-14-px text-secondary ${getClassName(
                        errors.email,
                        "is-invalid"
                      )}`}
                    />
                  </div>
                  {/* Phone: */}
                  <div
                    className={`form-group  col-sm-12 d-flex justify-content-between ${getClassName(
                      !isUpdate ||
                        rowData?.roleId === roleTypeEnums.EMAIL_ONLY ||
                        user?.roleId === roleTypeEnums.EMAIL_ONLY,
                      "d-none"
                    )}`}
                  >
                    <h6 htmlFor="phone" className="mt-2 col-md-2 col-4">
                      Phone:
                    </h6>
                    <Form.Group className="w-100">
                      <InputGroup className="d-flex w-100">
                        <InputGroup.Text
                          className={`fw-medium 
                          ${getClassName(
                            errors.phoneNumber,
                            "border border-danger"
                          )}
                      `}
                        >
                          {phoneConstants.COUNTRY_DISPLAY}
                        </InputGroup.Text>
                        <Form.Control
                          type="tel"
                          name="phoneNumber"
                          value={rowData?.phoneNumber}
                          data-testid="phone-number-field"
                          minLength={phoneConstants.LENGTH}
                          maxLength={phoneConstants.LENGTH}
                          {...register("phoneNumber", {
                            required: !(
                              rowData?.phoneNumber ||
                              !isUpdate ||
                              user?.roleId === roleTypeEnums.EMAIL_ONLY
                            ),
                            pattern: {
                              value: phoneConstants.PATTERN,
                            },
                            onChange: (e) => {
                              if (!isNaN(e.target.value)) handleChange(e);
                            },
                          })}
                          className={`form-control font-14-px text-secondary  ${getClassName(
                            errors.phoneNumber,
                            "is-invalid"
                          )}`}
                        />
                      </InputGroup>
                      <Form.Text className="text-muted">
                        <ul className="ps-4">
                          <li
                            className={`${getClassName(
                              rowData?.phoneNumber?.length ===
                                phoneConstants.LENGTH,
                              "text-success"
                            )}`}
                          >
                            <small>{phoneConstants.FORMAT_HINT}</small>
                          </li>
                        </ul>
                      </Form.Text>
                    </Form.Group>
                  </div>
                </div>
              </div>

              <div className="form-group mb-3 d-flex justify-content-between justify-content-sm-end">
                <button
                  type="submit"
                  className="btn user-permission-button px-4"
                >
                  {!isUpdate ? "Add" : "Update"}
                </button>
                <button
                  type="button"
                  className="btn user-permission-button px-4 mx-1"
                  onClick={() => {
                    closeAddUserWindow();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="notification-form card shadow">
          <div className="card-body p-0">
            <div className="mx-4 py-3">
              <h5 className="mb-0">Total Users</h5>
            </div>
            <div data-testid="userPermissionTable">
              {spinner(USER_PERMISSION_DATA) && <Spinner />}
              <DataTable
                columns={userPermissionColumns}
                data={permissionData}
                numberOfRowsPerPage={permissionDataPagination.size}
                totalRows={permissionDataPagination.totalElements}
                pageNumber={permissionDataPagination.number + 1}
                onPageChange={(pageNum) => getData(pageNum)}
                onColumnSort={(sortBy) =>
                  getData(permissionDataPagination.number, sortBy)
                }
                sortedBy={sorting}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

//Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  storesReducer: state.storesReducer,
  groupsReducer: state.groupsReducer,
  userData: state.userPermissionsReducer.user,
  authenticationUser: state.authentication.user,
  managers: state.managersReducer.managers?.data,
  imagePathFromHub: state.system.fromHub?.imagePath,
  managerCreated: state.managersReducer.managerCreated,
  userPermissionsReducer: state.userPermissionsReducer,
  allLocations: state.managersReducer.allLocations?.data,
});

//Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addUserPermission: (rowData) =>
    dispatch(userPermissionsActions.addUserPermission(rowData)),
  updateUsers: (rowData, userId) =>
    dispatch(userPermissionsActions.updateUsers(rowData, userId)),
  deleteUser: (userId) =>
    dispatch(userPermissionsActions.deleteUserDetails(userId)),
  getGroups: (brandId) => dispatch(groupsActions.getGroups(brandId)),
  getStoreById: (brandId) => dispatch(storeActions.getStoreById(brandId)),
  getLocationsByBrandId: (brandId) =>
    dispatch(groupsActions.getLocationByBrandId(brandId)),
  getAllBrands: (isActiveOnly) =>
    dispatch(storeActions.getAllBrands(isActiveOnly)),
  getAllBrandForFilterDropdown: () =>
    dispatch(storeActions.getAllBrandForFilterDropdown()),
  getUsers: (body) => dispatch(userPermissionsActions.getUsers(body)),
  resendCreatePasswordEmail: (userId) =>
    dispatch(userPermissionsActions.resendCreatePasswordEmail(userId)),
  resetStores: () => dispatch(storeActions.resetStores()),
  getUserById: (userId) => dispatch(userPermissionsActions.getUserById(userId)),
  setUserData: (data) => dispatch(userPermissionsActions.setUserData(data)),
  getBrandlocations: (groupId) =>
    dispatch(managersActions.getBrandlocations(groupId)),
});

//Mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(UserPermissions);
